import { environment } from '../../environments/environment';

export const ApiConfig = ( () => {
    const baseUrl = environment.flightConfig.apiUrl;
    let credentials;

    switch(baseUrl) {
        case 'https://dev.belairtrip.com/':
            credentials = {
                username: "belairtrip",
                password: "belair@321",
                officeid: "belairtrip"
            };
            break;
        case 'https://air.belairtrip.com/':
            credentials = {
                username: "MobileApp",
                password: "<JSb2cHj;4*gupEU",
                officeid: "MobileApp"
            };
            break;
        case 'https://dev.belair.in/':
            credentials = {
                username: "MobileApp",
                password: "<JSb2cHj;4*gupEU",
                officeid: "MobileApp"
            };
            break;
        case 'https://belair.in/':
            credentials = {
                username: "MobileApp",
                password: "<JSb2cHj;4*gupEU",
                officeid: "MobileApp"
            };
            break;
        default:
            credentials = {
                username: "MobileApp",
                password: "<JSb2cHj;4*gupEU",
                officeid: "MobileApp"
            };
    }
    return { baseUrl, credentials };
})();